import { useEffect, useState } from "react";
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../Auth/useAuth";
import { axiosInstance } from "../axiosInstance";
import { supportIdentity } from "./supportChatStorage";
import SupportChatWorkspace from "./SupportChatWorkspace";

export default function SupportChatLauncher() {
  const { user, isAuthenticated, sessionIssue } = useAuth();
  const location = useLocation();
  const scope = supportIdentity(user);
  return isAuthenticated && location.pathname !== "/support" ? <Launcher key={scope} paused={Boolean(sessionIssue)} /> : null;
}

function Launcher({ paused }) {
  const [capabilities, setCapabilities] = useState(null);
  const [open, setOpen] = useState(false);
  const [opened, setOpened] = useState(false);
  useEffect(() => {
    if (paused) return;
    let active = true;
    const load = () => axiosInstance.get("/support-chat/capabilities").then(response => { if (active) setCapabilities(response.data); }).catch(() => {});
    load(); const timer = setInterval(load, 30000);
    return () => { active = false; clearInterval(timer); };
  }, [paused]);
  if (!capabilities?.enabled) return null;
  return <>
    <Tooltip title="Chat with support" placement="left"><IconButton className="support-launcher" aria-label="Chat with support" onClick={() => { setOpened(true); setOpen(true); }}><ChatBubbleOutlineIcon /></IconButton></Tooltip>
    <Dialog className="support-dialog" open={open} onClose={() => setOpen(false)} keepMounted fullWidth maxWidth="md" aria-labelledby="support-chat-title">
      <DialogTitle id="support-chat-title" className="support-dialog-title"><span>Fieldprint support</span><div>
        {capabilities.operator && <Button size="small" component={Link} to="/support?inbox=1" endIcon={<OpenInNewIcon fontSize="small" />} onClick={() => setOpen(false)}>Private inbox</Button>}
        <IconButton aria-label="Close support chat" onClick={() => setOpen(false)}><CloseIcon /></IconButton>
      </div></DialogTitle>
      <DialogContent>
        {opened && <SupportChatWorkspace />}
      </DialogContent>
    </Dialog>
  </>;
}
